module.exports = __webpack_public_path__ + "static/media/document.248dbda4.png";